import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/beratung/$taxAdvisoryId/unternehmen/$companyId/"
)({
  component: CompanyIndexRoute,
});

function CompanyIndexRoute() {
  const { taxAdvisoryId, companyId } = Route.useParams();
  return (
    <Navigate
      to="/beratung/$taxAdvisoryId/unternehmen/$companyId/dokumente"
      params={{ taxAdvisoryId, companyId }}
      search={(prev) => ({ ...prev, detail: "dokumente" })}
      replace
    />
  );
}
